import React from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Crud from "../Crud";

/**
 * TABLE SYSTEMCOLORS
 */
function MLBEasterLineConversion() {
  return (
    <Crud
      title="MLB Eastern Line Conversion"
      getUrl={() => "/Profile/MLBEasternLine_GetList"}
      // INSERT
      insertUrl={() => "/Profile/MLBEasternLine_Insert"}
      insertParams={({ userId }, { maxOdds, minOdds, favOdds, dogOdds }) => ({
        MaxOdds: maxOdds,
        MinOdds: minOdds,
        FavOdds: favOdds,
        DogOdds: dogOdds,
        IdUser: Number(userId),
      })}
      // UPDATE
      updateUrl={() => "/Profile/MLBEasternLine_Update"}
      updateParams={({ userId }, { idMLBEasternLine, maxOdds, minOdds, favOdds, dogOdds }) => ({
        IdMLBEasternLine: idMLBEasternLine,
        MaxOdds: maxOdds,
        MinOdds: minOdds,
        FavOdds: favOdds,
        DogOdds: dogOdds,
        IdUser: Number(userId),
      })}
      // DELETE
      deleteUrl={() => "/Profile/MLBEasternLine_Delete"}
      deleteParams={({ userId }, id) => ({
        IdMLBEasternLine: id,
        IdUser: Number(userId),
      })}
    >
      <TableHeaderColumn
        visible="none"
        hiddenOnInsert
        autoValue={true}
        hidden
        isKey
        dataField="idMLBEasternLine"
      >
        Id
      </TableHeaderColumn>
      <TableHeaderColumn dataField="minOdds">Min ML Odds</TableHeaderColumn>
      <TableHeaderColumn dataField="maxOdds">Max ML Odds</TableHeaderColumn>
      <TableHeaderColumn dataField="dogOdds">Dog Eastern Odds</TableHeaderColumn>
      <TableHeaderColumn dataField="favOdds">Fav Eastern Odds</TableHeaderColumn>
    </Crud>
  );
}

export default MLBEasterLineConversion;
